import { useMutation } from '@apollo/client/react';
import { ADD_ICE_CANDIDATE, CREATE_OFFER } from './gql';

export default function useGraphQLFunctions() {
  // add ice candndate mutation

  const [addIceCandidateMutation] = useMutation(ADD_ICE_CANDIDATE);

  // create offer mutation
  const [createOfferMutation] = useMutation(CREATE_OFFER);

  return {
    addIceCandidateMutation,
    createOfferMutation,
  };
}
